import { GroupCreateRequest, GroupInput, GroupUpdateRequest } from '../../../types/app/group.types';

export const convertDataFromInputToCreateRequest = (data: GroupInput): GroupCreateRequest => ({
  name: data.name,
});

export const convertDataFromInputToUpdateRequest = (data: GroupInput): GroupUpdateRequest => ({
  id: data.id!,
  name: data.name,
});
